import { render, staticRenderFns } from "./BetslipD.vue?vue&type=template&id=38d67a5c&scoped=true"
import script from "./BetslipD.vue?vue&type=script&lang=js"
export * from "./BetslipD.vue?vue&type=script&lang=js"
import style0 from "./BetslipD.vue?vue&type=style&index=0&id=38d67a5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38d67a5c",
  null
  
)

export default component.exports